<template>
  <div class="wrapper">
    <Topo />
    <notifications></notifications>
    <side-bar class="d-print-none scrollMenu">
      <template slot="links">
        <sidebar-item :link="{
          name: 'Página Inicial',
          icon: 'fas fa-home text-light',
          path: '/home'
        }">
        </sidebar-item>

        <sidebar-item id="menuOkr" :link="{
          name: 'OKR',
          icon: 'fas fa-bullseye text-light',
        }" v-if="perfilColaborador || perfilCoordenador || perfilDiretor || perfilAdmin">
          <sidebar-item id="menuOkrCadastro"      :link="{ name: 'Cadastro',      path: '/okr-cadastro' }"></sidebar-item>
          <sidebar-item id="menuOkrMonitoramento" :link="{ name: 'Monitoramento', path: '/okr' }"></sidebar-item>
        </sidebar-item>

        <sidebar-item id="projetos" :link="{
          name: 'Projetos',
          icon: 'far fa-calendar-check text-light',
        }" v-if="perfilColaborador || perfilCoordenador || perfilDiretor || perfilAdmin">
          <sidebar-item :link="{ name: 'Cadastro', path: '/projeto-cadastro' }"></sidebar-item>
          <sidebar-item id="menuProjeto" :link="{ name: 'Listagem', path: '/projeto-listagem' }"></sidebar-item>
          <!--<sidebar-item :link="{ name: 'Painel', path: '/painel' }"></sidebar-item>-->
          <sidebar-item :link="{ name: 'Validação', path: '/projeto-validacao' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Pendente', path: '/projeto-pendente' }"></sidebar-item>      
        </sidebar-item>

        <sidebar-item id="menuAtividade" :link="{
          name: 'Atividades',
          icon: 'fas fa-calendar-check text-light',
         }" v-if="perfilColaborador || perfilCoordenador || perfilDiretor || perfilAdmin">
          <sidebar-item :link="{ name: 'Cadastro', path: '/atividade-cadastro' }"></sidebar-item>
          <sidebar-item id="atividade" :link="{ name: 'Listagem', path: '/atividade-listagem' }"></sidebar-item>
        </sidebar-item>

        <sidebar-item :link="{
          name: 'Usuários',
          icon: 'fas fa-users text-light',
          path: '/lead'
        }" v-if="perfilAdmin">
        </sidebar-item>

        <sidebar-item :link="{
          name: 'Estrutura',
          icon: 'fas fa-boxes text-light',
          path: '/estrutura'
        }" v-if="perfilAdmin">
        </sidebar-item>

        <sidebar-item :link="{
          name: 'Tipo Atividade',
          icon: 'fas fa-clipboard-list text-light',
          path: '/tipo-atividade'
        }" v-if="perfilAdmin">
        </sidebar-item>
        
        <sidebar-item :link="{
            name: 'Kanban',
            icon: 'fas fa-paper-plane text-light',
            path: '/kanban'
          }">
        </sidebar-item>
        
        <sidebar-item :link="{
          name: 'Meus Dados',
          icon: 'ni ni-credit-card text-light',
          path: '/meuperfil/meusdados'
        }">
        </sidebar-item>

        <!--
        <sidebar-item :link="{
          name: 'Portifólio',
          icon: 'fas fa-file-alt text-light',
          path: '/portifolio'
        }">
        </sidebar-item>
        -->

        <!--
        <sidebar-item :link="{
          name: 'Meu perfil',
          icon: 'ni ni-credit-card text-light',
        }">
          <sidebar-item :link="{ name: 'Meus Dados', path: '/meuperfil/meusdados' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Trocar senha', path: '/meuperfil/trocasenha' }"></sidebar-item>
        </sidebar-item>
        -->

        <sidebar-item :link="{
          name: 'Mensagem',
          icon: 'fas fa-envelope text-light',
          path: '/mensagem'
        }">
        </sidebar-item>

        <sidebar-item :link="{
          name: 'Logs',
          icon: 'fa fa-history text-light',
          path: '/log'
        }"  v-if="perfilAdmin">
        </sidebar-item>

        <sidebar-item :link="{ name: 'Sair', path: '/sair', icon: 'ni ni-button-power text-light' }"></sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <router-view></router-view>
        </fade-transition>
      </div>
    </div>
  </div>
</template>
<script>
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import Topo from "@/components/Topo.vue";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}
import { FadeTransition } from 'vue2-transitions';

export default {
	components: {
		FadeTransition,
		Topo
	},
	created(){
		this.selecionarPerfil();
	},
	data() {
		return {
			perfilAdmin: false,
			perfilColaborador: false,
			perfilCoordenador: false,
			perfilDiretor: false,
		};
	},
	methods: {
		selecionarPerfil() {
			let perfil = localStorage.getItem("pnome");
			console.log("perfil", perfil);
			this.perfilAdmin = (perfil === "ADMIN");
			this.perfilColaborador = (perfil === "COLABORADOR");
			this.perfilCoordenador = (perfil === "COORDENADOR");
			this.perfilDiretor = (perfil === "DIRETOR");
		},
		getProfile() {
			return localStorage.getItem("pid")
		},
		initScrollbar() {
			let docClasses = document.body.classList;
			let isWindows = navigator.platform.startsWith('Win');
			if (isWindows) {
				initScrollbar('scrollbar-inner');
				docClasses.add('perfect-scrollbar-on');
			} else {
				docClasses.add('perfect-scrollbar-off');
			}
		}
	}
};
</script>
<style lang="scss">
.scrollMenu {
  scrollbar-width: thin;
  overflow-x: hidden;
  overflow-y: auto;
}

.router-link-exact-active {
  background: #4682b4;
  //margin-right: 0.5rem;
  //margin-left: 0.5rem;
  //padding-left: 1rem;
  //padding-right: 1rem;
  border-radius: 0.375rem;
}

.navbar-vertical.navbar-expand-xs .navbar-nav>.nav-item>.nav-link.active {
  background: transparent !important;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border-radius: 0.375rem;
}
</style>
